import { useState } from "react";
import { toast } from "./Toast";

export default function ForwardModal({ onSubmit, onClose }) {
  const [recipient, setRecipient] = useState("");
  const [comment, setComment] = useState("");

  const handleSubmit = () => {
    if (recipient.trim() && recipient.includes("@")) {
      onSubmit(recipient, comment);
    } else {
      toast("გთხოვთ, შეიყვანოთ სწორი ელ. ფოსტის მისამართი.", "warning");
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-box">
        <h3>წერილის გადაგზავნა</h3>
        <input
          type="email"
          value={recipient}
          onChange={(e) => setRecipient(e.target.value)}
          placeholder="ელ. ფოსტის მისამართი..."
        />
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          placeholder="კომენტარის დამატება (სურვილისამებრ)..."
        />
        <div className="modal-buttons">
          <button className="cancel-btn" onClick={onClose}>გაუქმება</button>
          <button className="send-btn" onClick={handleSubmit} disabled={!recipient.trim()}>
            გადაგზავნა
          </button>
        </div>
      </div>
    </div>
  );
}
